"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementSelect = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var NONE_SELECTION_ID = "noneId";
var EngagementSelect = function (_a) {
    var algorithms = _a.algorithms, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, large = _a.large;
    var internalValue = value == null ? NONE_SELECTION_ID : value;
    var selectedAlgorithm = algorithms.find(function (_a) {
        var _id = _a._id;
        return _id === internalValue;
    });
    return (react_1.default.createElement(kaleidoscope_1.Select, { isNestedPortal: true, label: "Engagement algorithm", placeholder: "Select an option", value: internalValue, onChange: function (newValue) {
            return onChange(newValue === NONE_SELECTION_ID ? null : newValue);
        }, autoStack: true, icon: react_1.default.createElement(icons_1.Engagement, null), endElement: selectedAlgorithm && !selectedAlgorithm.enabled ? react_1.default.createElement(OffLabel, null) : undefined, disabled: disabled, size: large ? "l" : "m" },
        react_1.default.createElement(kaleidoscope_1.SelectOption, { value: NONE_SELECTION_ID }, "None"),
        algorithms.map(function (algo) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: algo._id, value: algo._id, endElement: !algo.enabled ? react_1.default.createElement(OffLabel, null) : undefined }, algo.name)); })));
};
exports.EngagementSelect = EngagementSelect;
var OffLabel = function () { return react_1.default.createElement(kaleidoscope_1.Label, { secondary: true }, "OFF"); };
